gform.addFilter('gform_datepicker_options_pre_init', function (optionsObj, formId, fieldId) {
    const overrideOptions = {
        changeMonth: false,
        changeYear: true,
        showButtonPanel: true,
        closeText: 'Close'
    };
    optionsObj = {...optionsObj, ...overrideOptions};
    return optionsObj;
});

document.addEventListener('DOMContentLoaded', () => {
    const isMobile = () => {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) 
               || (window.matchMedia && window.matchMedia("(max-width: 768px)").matches);
    };
    
    const initializeSelectBox = ($select) => {
        if (isMobile()) {
            const $firstOption = $select.find('option:first');
            if ($firstOption.val() === '' || $firstOption.text().toLowerCase().includes('select')) {
                $firstOption.prop('disabled', true);
            }
        }
        
        $select.selectBoxIt({
            autoWidth: false,
            theme: "jqueryui",
            native: isMobile(),
            create: function(event) {
                const $target = jQuery(event.target);
                $target.parent().find('ul').css('display', 'none');
                
                if (!isMobile()) {
                    setTimeout(() => {
                        const $firstOption = $target.find('option:first');
                        if ($firstOption.val() === '' || $firstOption.text().toLowerCase().includes('select')) {
                            const $selectBoxItContainer = $target.next('.selectboxit-container');
                            const $dropdownList = $selectBoxItContainer.find('.selectboxit-options');
                            
                            $dropdownList.find('li:first').css({
                                'display': 'none',
                                'visibility': 'hidden',
                                'height': '0',
                                'padding': '0',
                                'margin': '0',
                                'overflow': 'hidden'
                            });
                        }
                    }, 10);
                }
            },
            open: function() {
                if (!isMobile()) {
                    const $selectBoxItContainer = jQuery(this).next('.selectboxit-container');
                    const $dropdownList = $selectBoxItContainer.find('.selectboxit-options');
                    const $firstOption = jQuery(this).find('option:first');
                    
                    if ($firstOption.val() === '' || $firstOption.text().toLowerCase().includes('select')) {
                        $dropdownList.find('li:first').css({
                            'display': 'none',
                            'visibility': 'hidden',
                            'height': '0',
                            'padding': '0',
                            'margin': '0',
                            'overflow': 'hidden'
                        });
                    }
                }
            }
        });
    };
    
    jQuery('form select').each(function() {
        initializeSelectBox(jQuery(this));
    });
    
    jQuery(document).on('gform_post_render', function(event, form_id, current_page) {
        jQuery('#gform_' + form_id + ' select').each(function() {
            const $select = jQuery(this);
            
            if (!$select.data('selectBox-selectBoxIt')) {
                initializeSelectBox($select);
            }
        });
    });
});